import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import useCurrentBusinessUnit from '../hooks/useCurrentBusinessUnit';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BUTagHack = styled.span.withConfig({
  displayName: "BUTooltipHeaderText__BUTagHack"
})(({
  theme
}) => `
  /**
   * Hack to make the BU tag smaller
   **/
  .bu-tag {
    * {
      height: ${theme.space['600']}px;
      width: ${theme.space['600']}px;
    }
  }
`);
const HeadingText = ({
  children,
  ['data-test-id']: dataTestId
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    typography: "heading-25",
    use: "on-dark",
    children: /*#__PURE__*/_jsx(BUTagHack, {
      children: /*#__PURE__*/_jsx(Flex, {
        as: "div",
        alignItems: "center",
        borderBlockEndWidth: "100",
        borderBlockEndStyle: "solid",
        borderBlockEndColor: "border-core-hover",
        paddingBlock: "250",
        paddingInline: "400",
        inlineSize: "100%",
        "data-test-id": dataTestId,
        children: children
      })
    })
  });
};
const BUName = styled.span.withConfig({
  displayName: "BUTooltipHeaderText__BUName"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
export default function BUTooltipHeaderText() {
  const currentBusinessUnit = useCurrentBusinessUnit();
  if (!currentBusinessUnit) {
    return /*#__PURE__*/_jsx(HeadingText, {
      "data-test-id": "bu-tooltip-header-text-all-bus",
      children: /*#__PURE__*/_jsx(BUName, {
        title: I18n.text('frameworkListingLib.buSelect.allBUs_buv2'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.buSelect.allBUs_buv2"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(HeadingText, {
    "data-test-id": "bu-tooltip-header-text",
    children: [/*#__PURE__*/_jsx("span", {
      className: "bu-tag",
      children: /*#__PURE__*/_jsx(BusinessUnitTag, {
        buOptions: [currentBusinessUnit],
        buId: currentBusinessUnit.id,
        onlyLogo: true
      })
    }), /*#__PURE__*/_jsx(BUName, {
      title: currentBusinessUnit.name,
      children: currentBusinessUnit.name
    })]
  });
}